import { Icon } from '@fullstory/components';
import { ObjectType } from '@fullstory/proto/fs/services/dx-objects';
import { LibraryObjectType } from '@fullstory/routes';
import { intl } from '@fullstory/intl';

export const OBJECT_TYPE_TO_LABEL: {
  [key in LibraryObjectType]: string;
} = {
  [ObjectType.DASHBOARD]: intl.formatMessage({ defaultMessage: 'Dashboards', id: 'nwqt7T' }),
  [ObjectType.SEGMENT]: intl.formatMessage({ defaultMessage: 'Segments', id: 'VF3DcR' }),
  [ObjectType.METRIC]: intl.formatMessage({ defaultMessage: 'Metrics', id: 'HNBpJ4' }),
  [ObjectType.FUNNEL]: intl.formatMessage({ defaultMessage: 'Funnels', id: 'puhcpn' }),
  [ObjectType.RETENTION]: intl.formatMessage({ defaultMessage: 'Retention', id: 'nL6Jl0' }),
  [ObjectType.JOURNEY]: intl.formatMessage({ defaultMessage: 'Journeys', id: '08hqOd' }),
  [ObjectType.HEATMAP]: intl.formatMessage({ defaultMessage: 'Heatmaps', id: 'geWuHd' }),
  [ObjectType.DATA_TABLE]: intl.formatMessage({ defaultMessage: 'Tables', id: 'b7YdZ/' }),
} as const;

export const OBJECT_TYPE_TO_ICON_NAME: {
  [key in LibraryObjectType]: React.ComponentProps<typeof Icon>['name'];
} = {
  [ObjectType.DASHBOARD]: 'dashboard',
  [ObjectType.SEGMENT]: 'segments',
  [ObjectType.METRIC]: 'metrics',
  [ObjectType.FUNNEL]: 'funnels',
  [ObjectType.RETENTION]: 'retention',
  [ObjectType.JOURNEY]: 'journeys',
  [ObjectType.HEATMAP]: 'heatmap',
  [ObjectType.DATA_TABLE]: 'data-table',
} as const;

export const libraryObjectTypeMessages: { [key in Partial<LibraryObjectType>]: string } = {
  [ObjectType.FUNNEL]: intl.formatMessage({ defaultMessage: 'Funnel', id: 'vOE+PU' }),
  [ObjectType.HEATMAP]: intl.formatMessage({ defaultMessage: 'Heatmap', id: 'WEDRDw' }),
  [ObjectType.JOURNEY]: intl.formatMessage({ defaultMessage: 'Journey', id: 'btihtD' }),
  [ObjectType.METRIC]: intl.formatMessage({ defaultMessage: 'Metric', id: 'yypztr' }),
  [ObjectType.RETENTION]: intl.formatMessage({ defaultMessage: 'Retention', id: 'nL6Jl0' }),
  [ObjectType.SEGMENT]: intl.formatMessage({ defaultMessage: 'Segment', id: 'OrwKQ+' }),
  [ObjectType.DASHBOARD]: intl.formatMessage({ defaultMessage: 'Dashboard', id: 'hzSNj4' }),
  [ObjectType.DATA_TABLE]: intl.formatMessage({ defaultMessage: 'Table', id: 'IeBejt' }),
} as const;
